import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions
} from "@mui/material";

import { mockParticipacoes } from '../mock'
import { formatoMascaras, aplicaMascara, validateCNPJ } from '../util';
import limiteTamanhoCampos from '../limiteCampos';

const listaPartirticipacoes = mockParticipacoes();

const FormularioDados = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.formData);
  const [dialogDocInvalido, setDialogDocInvalido] = useState(false);

  const [validacao, setValidacao] = useState(
    {
      razaoSocial: false,
      nomeFantasia: false,
      cnpj: false
    });

  useEffect(() => {
    validaForm();
    props.onChildDataChange(formData);
  }, [formData]);

  useEffect(() => {
    validaForm();
  }, []);

  const validaForm = () => {
    const propriedades = Object.keys(validacao);
    const novaValidacao = { ...validacao };

    propriedades.forEach(propriedade => {
      if (formData) {
        const seNaoCabeValidacaoQuinze = formData?.menorDe15 != 'true' && propriedade.includes('RepresentanteQuinze');
        const seNaoCabeValidacaoFalecido = formData?.falecido != 'true' && propriedade.includes('OutorganteFalecid');
        const cnpjInvalido = propriedade == 'cnpj' && !validateCNPJ(formData[propriedade])

        if (cnpjInvalido && formData[propriedade] && formData[propriedade].length >= formatoMascaras().CNPJ.length) {
          setDialogDocInvalido(true);
          novaValidacao[propriedade] = false;
        }
        else if (cnpjInvalido) {
          novaValidacao[propriedade] = false;
        }
        else if (!(seNaoCabeValidacaoQuinze || seNaoCabeValidacaoFalecido))
          novaValidacao[propriedade] = formData[propriedade] !== "" && formData[propriedade] != undefined && formData[propriedade] != null;
        else
          novaValidacao[propriedade] = true;
      }
    });

    setValidacao(novaValidacao);
  }

  const handleChange = (event, selectRequired) => {
    let { name, value, type, required } = event.target;

    value = limiteTamanhoCampos(name, value);

    if (name == 'cnpj')
      value = aplicaMascara(value.replace(/\D/g, ''), formatoMascaras().CNPJ)

    setFormData({
      ...formData,
      [name]: value,
    });

    if (required)
      setValidacao({
        ...validacao,
        [name]: type === 'text' ? value && value.toString().trim() !== '' : value,
      });

    if (selectRequired)
      setValidacao({
        ...validacao,
        [name]: value && value.toString().trim() !== '',
      });
  };

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Dados da Empresa
      </Typography>
      <form>
        <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Razão Social"
              variant="outlined"
              margin="normal"
              name="razaoSocial"
              value={formData?.razaoSocial}
              onChange={handleChange}
              required
              error={!validacao.razaoSocial}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Nome Fantasia"
              variant="outlined"
              margin="normal"
              name="nomeFantasia"
              value={formData?.nomeFantasia}
              onChange={handleChange}
              required
              error={!validacao.nomeFantasia}
            />
          </Grid>
          <Grid item sm={6}>
            <TextField
              fullWidth
              label="CNPJ"
              variant="outlined"
              margin="normal"
              name="cnpj"
              value={formData?.cnpj}
              onChange={handleChange}
              required
              error={!validacao.cnpj}
            />
          </Grid>
          <Grid item xs={12}>
            <FormLabel component="legend">
              Informações adicionais sobre sua carreira. Estas informações servirão para a análise que precisamos fazer para que possamos avaliar seu pedido de filiação.
            </FormLabel>
            <TextField
              fullWidth
              label="Nos informe aqui..."
              variant="outlined"
              margin="normal"
              name="sobreCarreira"
              value={formData?.sobreCarreira}
              onChange={handleChange}
              multiline
              rows={4}
              inputProps={{ maxLength: 250 }}
              helperText="Máximo de 250 caracteres"
            />
          </Grid>
          <Grid item sm={12}>
            <FormLabel component="legend">
              Suas músicas ou participações em gravações já estão sendo executadas publicamente?
            </FormLabel>
            <FormControl fullWidth variant="outlined" margin="normal">
              <InputLabel>Se sim, informe onde</InputLabel>
              <Select
                name="musicasPublicas"
                value={formData?.musicasPublicas}
                onChange={(e) => handleChange(e, true)}
                label="musicasPublicas"
              >
                {listaPartirticipacoes.map((musica) => (
                  <MenuItem key={musica.id} value={musica.id}>
                    {musica.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </form>

      <Dialog
        open={dialogDocInvalido}
        onClose={() => setDialogDocInvalido(false)}
        aria-labelledby="dialog-titulo"
      >
        <DialogTitle id="dialog-titulo">CNPJ inválido</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Caro(a) Usuário o texto inserido não é um CNPJ válido.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogDocInvalido(false)} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
});

export default FormularioDados;
